(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-upsell"] && !Shopify.designMode) return;
  try {
    // Idempotent: cart-drawer re-renders innerHTML on every cart change,
      // så vi binder via delegation från document istället för per-knapp.
      (function () {
        if (window.__nsUpsellBound) return;
        window.__nsUpsellBound = true;

        document.addEventListener('click', async function (event) {
          const btn = event.target.closest('[data-ns-upsell-add]');
          if (!btn || btn.disabled) return;

          const variantId = btn.dataset.variantId;
          if (!variantId) return;

          event.preventDefault();
          btn.dataset.loading = 'true';
          btn.disabled = true;

          try {
            const body = JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            });

            const res = await fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: body
            });

            if (!res.ok) throw new Error('Cart add failed: ' + res.status);
            const data = await res.json();

            // Återanvänd Dawn's CartDrawer.renderContents om det finns
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
              drawer.renderContents({ sections: data.sections, id: variantId });
            } else if (data.sections && data.sections['cart-drawer']) {
              // Fallback: byt ut .drawer__inner manuellt
              const parser = new DOMParser();
              const doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
              const fresh = doc.querySelector('.drawer__inner');
              const live = document.querySelector('#CartDrawer .drawer__inner');
              if (fresh && live) live.innerHTML = fresh.innerHTML;
            }

            // Notify övrig Dawn-kod (t.ex. cart bubble) om cart-update
            if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ns-upsell', productVariantId: variantId });
            }
          } catch (err) {
            console.error('[ns-upsell] add failed', err);
            btn.disabled = false;
          } finally {
            btn.dataset.loading = 'false';
          }
        }, { passive: false });
      })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["exit-intent-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nsExitBound) return;
    window.__nsExitBound = true;

    const STORAGE_SEEN = 'nsExitIntentSeen';
    const STORAGE_SUB = 'nsExitIntentSubscribed';
    const root = document.getElementById('ns-exit-intent');
    if (!root) return;

    const path = window.location.pathname;
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) return;

    const storageOk = (() => {
      try {
        if (localStorage.getItem(STORAGE_SEEN) || localStorage.getItem(STORAGE_SUB)) return false;
        return true;
      } catch (e) { return true; }
    })();
    if (!storageOk) return;

    const formState = root.querySelector('[data-ns-exit-state="form"]');
    const successState = root.querySelector('[data-ns-exit-state="success"]');
    const errorEl = root.querySelector('[data-ns-exit-error]');

    let isOpen = false;
    let hasShown = false;

    const open = () => {
      if (isOpen || hasShown) return;
      hasShown = true;
      isOpen = true;
      root.style.display = 'flex';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        root.dataset.open = 'true';
      }));
      try { localStorage.setItem(STORAGE_SEEN, '1'); } catch (e) {}
      const input = root.querySelector('.ns-exit__input');
      if (input) setTimeout(() => input.focus(), 350);
    };

    const close = () => {
      isOpen = false;
      root.dataset.open = 'false';
      setTimeout(() => { root.style.display = 'none'; }, 280);
    };

    // Trigger 1: mouseleave top edge (desktop)
    let armed = false;
    setTimeout(() => { armed = true; }, 6000);
    document.addEventListener('mouseleave', (e) => {
      if (!armed || isOpen || hasShown) return;
      if (e.clientY <= 0) open();
    });

    // Trigger 2: mouseout fallback (mer kompatibel än mouseleave i vissa miljöer)
    document.addEventListener('mouseout', (e) => {
      if (!armed || isOpen || hasShown) return;
      if (!e.relatedTarget && e.clientY <= 5) open();
    });

    // Trigger 3: visibilitychange (när tab byts/minimeras — fungerar överallt inkl. iframes)
    document.addEventListener('visibilitychange', () => {
      if (!armed || isOpen || hasShown) return;
      if (document.visibilityState === 'hidden') open();
    });

    // Trigger 4: scroll-djup (touch/no-hover)
    const hasFineHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!hasFineHover) {
      let scrollFired = false;
      const onScroll = () => {
        if (scrollFired || isOpen || hasShown) return;
        const scrolled = window.scrollY + window.innerHeight;
        const doc = document.documentElement.scrollHeight;
        if (doc > 0 && scrolled / doc >= 0.6) {
          scrollFired = true;
          open();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Trigger 5: time fallback
    setTimeout(() => { if (!isOpen && !hasShown) open(); }, 30000);

    // ESC close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) close();
    });

    // Close buttons + overlay
    root.querySelectorAll('[data-ns-exit-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    // Form submit
    const form = root.querySelector('[data-ns-exit-form]');
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const email = form.querySelector('input[type="email"]').value.trim();
        const btn = form.querySelector('.ns-exit__submit');
        errorEl.style.display = 'none';

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          errorEl.textContent = 'Skriv en giltig e-postadress.';
          errorEl.style.display = 'block';
          return;
        }

        btn.dataset.loading = 'true';
        btn.disabled = true;

        try {
          const fd = new FormData();
          fd.append('form_type', 'customer');
          fd.append('utf8', '✓');
          fd.append('contact[email]', email);
          fd.append('contact[accepts_marketing]', 'true');
          fd.append('contact[tags]', 'exit-intent-popup');

          await fetch('/contact#contact_form', {
            method: 'POST',
            body: fd,
            credentials: 'same-origin',
            mode: 'no-cors'
          });

          // Optimistic success — vi vet inte exakta resultatet pga no-cors
          // men POSTen är skickad och Shopify behandlar den
          try { localStorage.setItem(STORAGE_SUB, '1'); } catch (e) {}
          formState.style.display = 'none';
          successState.style.display = 'block';
        } catch (error) {
          console.error('[ns-exit] subscribe error', error);
          // Trots fel — visa success för UX, mailet är ofta sparat även vid network-fel
          try { localStorage.setItem(STORAGE_SUB, '1'); } catch (e) {}
          formState.style.display = 'none';
          successState.style.display = 'block';
        } finally {
          btn.dataset.loading = 'false';
          btn.disabled = false;
        }
      });
    }

    // Copy code
    const copyBtn = root.querySelector('[data-ns-exit-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', async () => {
        const code = root.dataset.discountCode;
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
          } else {
            const ta = document.createElement('textarea');
            ta.value = code;
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            ta.remove();
          }
          const original = copyBtn.textContent;
          copyBtn.textContent = 'Kopierad';
          setTimeout(() => { copyBtn.textContent = original; }, 1800);
        } catch (err) {
          console.warn('[ns-exit] clipboard error', err);
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["free-shipping-progress"] && !Shopify.designMode) return;
  try {
    // JS-fallback: sätter --ns-progress på root-elementet (rail ärver via var()).
  // Idempotent. Skyddar mot inline style filtrering.
  (function () {
    if (window.__nsShipProgressBound) return;
    window.__nsShipProgressBound = true;

    const apply = (root) => {
      (root || document).querySelectorAll('[data-ns-ship-progress]').forEach((el) => {
        const pct = parseFloat(el.getAttribute('data-progress'));
        if (!isNaN(pct)) {
          const clamped = Math.max(0, Math.min(100, pct));
          el.style.setProperty('--ns-progress', clamped + '%');
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => apply(document));
    } else {
      apply(document);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        requestAnimationFrame(() => apply(document));
      });
    }

    const drawer = document.querySelector('#CartDrawer');
    if (drawer && 'MutationObserver' in window) {
      const mo = new MutationObserver(() => apply(drawer));
      mo.observe(drawer, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nsStickyAtcBound) return;
    window.__nsStickyAtcBound = true;

    const log = (...args) => console.log('[ns-sticky]', ...args);

    const init = () => {
      const bar = document.querySelector('[data-ns-sticky-atc]');
      if (!bar) { log('bar saknas i DOM'); return; }

      // Hitta produktformulär — testa flera mönster
      const productForm =
        document.querySelector('product-form form') ||
        document.querySelector('form[action$="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[data-type="add-to-cart-form"]');

      if (!productForm) { log('ingen product-form hittad'); return; }
      log('product-form OK', productForm);

      // Bredare selector för submit-knappen — testa i prioritetsordning
      const mainSubmitBtn =
        productForm.querySelector('button[name="add"]') ||
        productForm.querySelector('[type="submit"][name="add"]') ||
        productForm.querySelector('button.product-form__submit') ||
        productForm.querySelector('button[type="submit"]') ||
        productForm.querySelector('[type="submit"]') ||
        // Sista chansen: vilken knapp som helst inom produktformuläret som inte är variant-väljare
        Array.from(productForm.querySelectorAll('button')).find(b =>
          !b.closest('.product-form__quantity, fieldset, .product-form__input')
        );

      if (!mainSubmitBtn) { log('ingen submit-knapp hittad i product-form'); return; }
      log('submit OK', mainSubmitBtn);

      const titleEl = bar.querySelector('[data-ns-sticky-title]');
      const priceEl = bar.querySelector('[data-ns-sticky-price]');
      const mediaEl = bar.querySelector('[data-ns-sticky-media]');
      const btn = bar.querySelector('[data-ns-sticky-btn]');

      const refresh = () => {
        const titleSrc = document.querySelector('.product__title h1, .product__title h2, h1.product__title, .product__info-container h1, h1');
        if (titleSrc && titleEl) titleEl.textContent = titleSrc.textContent.trim();

        const priceSrc = document.querySelector('.price__container .price-item--regular, .price-item--sale, .price-item--regular, [data-product-price], .product__price .price-item, .price__regular');
        if (priceSrc && priceEl) priceEl.textContent = priceSrc.textContent.trim();

        const imgSrc = document.querySelector('.product__media-item.is-active img, .product__media img, media-gallery img, .product__media-item img, .product-media img');
        if (imgSrc && mediaEl) {
          const existing = mediaEl.querySelector('img');
          const src = imgSrc.currentSrc || imgSrc.src;
          if (!existing) {
            const img = document.createElement('img');
            img.src = src;
            img.alt = '';
            img.loading = 'lazy';
            mediaEl.appendChild(img);
          } else if (existing.src !== src) {
            existing.src = src;
          }
        }

        const isDisabled = mainSubmitBtn.disabled || mainSubmitBtn.getAttribute('disabled') !== null;
        btn.disabled = isDisabled;
        if (isDisabled) {
          btn.querySelector('.ns-sticky-atc__btn-label').textContent =
            mainSubmitBtn.textContent.trim() || 'Slutsåld';
        } else {
          btn.querySelector('.ns-sticky-atc__btn-label').textContent = 'Lägg i varukorgen';
        }
      };

      refresh();
      // Säkerställ att baren INTE är hidden (bara dold via transform tills den ska visas)
      bar.removeAttribute('hidden');

      // Klick → trigga ursprungs-submit
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (btn.disabled) return;
        btn.dataset.loading = 'true';
        log('triggar submit på huvudknapp');
        mainSubmitBtn.click();
        setTimeout(() => { btn.dataset.loading = 'false'; }, 1500);
      });

      // Variant-byte lyssnare
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        if (PUB_SUB_EVENTS.variantChange) {
          subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(refresh));
        }
        if (PUB_SUB_EVENTS.optionValueSelectionChange) {
          subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => requestAnimationFrame(refresh));
        }
      }

      if ('MutationObserver' in window) {
        const mo = new MutationObserver(() => refresh());
        mo.observe(mainSubmitBtn, { attributes: true, childList: true, subtree: true });
        const priceContainer = document.querySelector('.price, .price__container, .product__price');
        if (priceContainer) mo.observe(priceContainer, { childList: true, subtree: true, characterData: true });
      }

      // Visa/dölj via IntersectionObserver
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              bar.dataset.visible = 'false';
              bar.setAttribute('aria-hidden', 'true');
            } else {
              bar.dataset.visible = 'true';
              bar.setAttribute('aria-hidden', 'false');
              log('visar bar (huvudknapp ur viewport)');
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
        io.observe(mainSubmitBtn);
        log('IntersectionObserver bunden till', mainSubmitBtn);
      } else {
        // Fallback: visa efter scroll > 600px
        const onScroll = () => {
          bar.dataset.visible = window.scrollY > 600 ? 'true' : 'false';
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
